<script setup lang="ts">
import { computed, ref } from 'vue';
import type { ElScrollbar } from 'element-plus';

const props = withDefaults(defineProps<Props>(), {
  wrapClass: 'ui-scrollbar',
  viewClass: 'ui-scrollbar__view-box',
  wrapStyle: '',
  viewStyle: '',
  native: false,
  outside: false,
});

const scrollBarRef = ref<InstanceType<typeof ElScrollbar> | null>(null);

interface Props {
  wrapClass?: string;
  viewClass?: string;
  wrapStyle?: string;
  viewStyle?: string;
  native?: boolean;
  outside?: boolean;
}

const outsideScroll = computed(() => {
  return props.outside ? 'margin-right: 10px;' : '';
});

defineExpose({
  scrollBarRef,
});
</script>

<template>
  <ElScrollbar
    ref="scrollBarRef"
    :wrap-class="wrapClass"
    :view-class="viewClass"
    :wrap-style="wrapStyle"
    :view-style="outsideScroll + viewStyle"
    :native="native"
  >
    <slot />
  </ElScrollbar>
</template>
